<template>
  <div class="flex items-center justify-center min-h-screen">
    <div class="relative w-24 h-24">
      <div
        class="absolute w-full h-2 transition-colors duration-500 ease-in-out top-[-9px]"
        :class="currentColorClass"
      ></div>

      <div
        class="absolute w-full h-2 transition-colors duration-500 ease-in-out bottom-[1px]"
        :class="currentColorClass"
      ></div>

      <div
        class="absolute h-2 w-[138%] transition-colors duration-500 ease-in-out rotate-[-46deg] top-[91%] left-[-1%] origin-top-left"
        :class="currentColorClass"
      ></div>
    </div>
  </div>
</template>
  
  <script>
export default {
  data() {
    return {
      colors: ["bg-[#008600]", "bg-[#35d7ff]"],
      currentColorIndex: 0,
    };
  },
  computed: {
    currentColorClass() {
      return this.colors[this.currentColorIndex];
    },
  },
  mounted() {
    this.startColorChange();
  },
  methods: {
    startColorChange() {
      setInterval(() => {
        this.currentColorIndex =
          (this.currentColorIndex + 1) % this.colors.length;
      }, 500);
    },
  },
};
</script>
  
  <style scoped>
</style>
  